export default function calculateDistance(pointA: { lat: number; lng: number }, pointB: { lat: number; lng: number }): number {
    const R = 6371e3 // Erdradius in Metern
    const phi1 = (pointA.lat * Math.PI) / 180
    const phi2 = (pointB.lat * Math.PI) / 180
    const deltaPhi = ((pointB.lat - pointA.lat) * Math.PI) / 180
    const deltaLambda = ((pointB.lng - pointA.lng) * Math.PI) / 180

    const a = Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) + Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2)

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

    return R * c // Distanz in Metern
}
